import { KIND, SIZE } from 'baseui/button'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'
import ModalExportLogsTable from './Bones/ModalExportLogsTable/ModalExportLogsTable'
import { Upload } from 'baseui/icon'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import useExportLogs from './useExportLogs'

const ExportLogs = () => {
  const { t, isAdmin, isOpen, logs, closeModal, fetchSubscriptionLogs } = useExportLogs()

  if (isAdmin === false) {
    return ''
  }

  return (
    <>
      <SDButton
        id='export-log-save-button'
        kind={KIND.secondary}
        size={SIZE.compact}
        onClick={event => {
          event.preventDefault()
          fetchSubscriptionLogs()
        }}
      >
        <Upload size={24} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
        {t('subscriptionTools:tools.export_logs_button')}
      </SDButton>

      <Modal
        onClose={closeModal}
        isOpen={isOpen}
        size={SIZE.default}
        overrides={{
          Dialog: {
            style: {
              width: '80vw',
            },
          },
        }}
      >
        <ModalHeader>{t('subscriptionForm:subscription_actions_module.export_logs.modal_header')}</ModalHeader>
        <ModalBody style={{ flex: '1 1 0' }}>
          <ModalExportLogsTable data={logs} />
        </ModalBody>
        <ModalFooter>
          <ModalButton kind={KIND.primary} onClick={closeModal}>
            {t('subscriptionForm:subscription_actions_module.export_logs.modal_close_button')}
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ExportLogs
